import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/features/shared/components/ui/button';

interface State {
  hasError: boolean;
  message: string;
}

/** Contains any My Pay render error to this page (instead of bubbling to the app
 *  ErrorBoundary, which sends the user back to the dashboard). Shows the actual
 *  message so issues are diagnosable in the field. */
export class MyPayBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message || String(error) };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[MyPay] render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="space-y-6">
          <div className="border-b border-border pb-6">
            <h1 className="text-h1 text-charcoal">My Pay</h1>
          </div>
          <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-border py-16 text-center">
            <AlertTriangle className="h-8 w-8 text-[#991B1B]" />
            <p className="font-medium text-charcoal">My Pay hit a snag</p>
            <p className="max-w-md text-sm text-muted-foreground">{this.state.message}</p>
            <Button variant="outline" onClick={() => this.setState({ hasError: false, message: '' })}>
              Try again
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
